"use client";

import { useEffect, useState } from "react";
import { I18NProvider as I18NProviderSearchX } from "@costar-search-x/i18n";

const MessageProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const [searchXMessages, setSearchXMessages] = useState(undefined);
  useEffect(() => {
    const getMessages = async () => {
      const [searchXMessages] = await Promise.all([
        import("@costar-search-x/i18n/dist/generated/language-pack.fr-FR"), //now that we are only 1 culture perhaps just load this in the search -x implementations?
      ]);

      setSearchXMessages({ ...(searchXMessages?.default as any) });
    };
    getMessages();
  }, []);

  return searchXMessages ? (
    <I18NProviderSearchX messages={searchXMessages}>
      {children}
    </I18NProviderSearchX>
  ) : null;
};

export { MessageProvider };
